var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"about-who-we"},[_c('div',{staticClass:"about-who-we__bg_image"},[_c('AboutPageWhoWeAreContent',{staticClass:"d-none d-sm-block"})],1),_c('AboutPageWhoWeAreContent',{staticClass:"d-sm-none"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }